<template>
  <v-card>
    <v-card-title>
      <span class="secondary--text ml-6 font-weight-bold text-subtitle-1">
        {{
          $t(
            'fleet_management.points_of_interest.points_of_interest_detail.edit_point'
          )
        }}
      </span>
    </v-card-title>
    <v-divider></v-divider>

    <v-card-text>
      <v-form ref="form" v-model="valid">
        <v-container>
          <v-row>
            <v-col cols="6">
              <span class="tertiary--text text-body-2">
                {{
                  $t(
                    'fleet_management.points_of_interest.create_points_of_interest.labels.new_poi_name'
                  )
                }}
              </span>
              <v-text-field
                v-model.trim="pointsOfInterestName"
                :counter="40"
                :rules="nameRules"
                filled
                dense
                required
                color="tertiary"
                ref="pointsOfInterestName"
              />
            </v-col>
            <v-col cols="4">
              <span class="tertiary--text text-body-2">
                {{
                  $t(
                    'fleet_management.points_of_interest.points_of_interest_detail.type_fields'
                  )
                }}
              </span>
              <v-select
                v-model="selectedCategory"
                :items="category"
                return-object
                dense
                filled
                item-text="name"
                color="tertiary"
              >
              </v-select>
            </v-col>
            <v-col cols="2">
              <span class="tertiary--text text-body-2">
                {{
                  $t(
                    'fleet_management.points_of_interest.points_of_interest_detail.icon_fields'
                  )
                }}
              </span>
              <v-select
                v-model="selectedCategoryIcons"
                :items="categoryIcons"
                return-object
                dense
                filled
                item-text="name"
                color="tertiary"
                @change="handleIconChange"
              >
                <template v-slot:item="{ item }">
                  <div
                    class="d-flex justify-center align-center"
                    style="width: 100%;"
                  >
                    <v-icon>{{ item.icon }}</v-icon>
                  </div>
                </template>

                <template v-slot:selection>
                  <div class="d-flex justify-center align-center">
                    <v-icon>{{ getIcon }}</v-icon>
                  </div>
                </template>
              </v-select>
            </v-col>
          </v-row>
          <v-row justify="center" class="mt-0">
            <v-col cols="6">
              <div class="tertiary--text text-body-2">
                {{
                  $t(
                    'fleet_management.points_of_interest.points_of_interest_detail.color_fields'
                  )
                }}
              </div>
              <v-color-picker
                v-model="pointColor"
                dot-size="23"
                hide-canvas
                hide-inputs
                hide-mode-switch
                hide-sliders
                mode="hexa"
                show-swatches
                swatches-max-height="100"
                :disabled="loading"
                :error="!selectPointColor"
                error-messages="Debe seleccionar un color"
                ref="colorPickerRef"
              ></v-color-picker>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <span class="tertiary--text text-center">
                {{
                  $t(
                    'fleet_management.points_of_interest.create_points_of_interest.get_latitude_and_longitude'
                  )
                }}
              </span>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col>
              <v-card color="#f1f1f1" elevation="0">
                <v-card-text>
                  <v-row dense>
                    <v-col cols="12">
                      <span class="tertiary--text text-body-2">
                        {{
                          $t(
                            'fleet_management.points_of_interest.points_of_interest_detail.location_fields'
                          )
                        }}:
                      </span>
                      <span class="secondary--text">
                        {{ getGeocodeResult }}
                      </span>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="6">
                      <span class="tertiary--text text-body-2">
                        {{
                          $t(
                            'fleet_management.points_of_interest.points_of_interest_detail.lat_fields'
                          )
                        }}:
                      </span>
                      <span class="secondary--text">
                        {{ getPointOfInterestGeoCoordinates.lat }}
                      </span>
                    </v-col>
                    <v-col cols="6">
                      <span class="tertiary--text text-body-2">
                        {{
                          $t(
                            'fleet_management.points_of_interest.points_of_interest_detail.long_fields'
                          )
                        }}:
                      </span>

                      <span class="secondary--text">{{
                        getPointOfInterestGeoCoordinates.lng
                      }}</span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <!--          <v-row class="d-flex justify-center">-->
          <!--            <v-col cols="3">-->
          <!--              <v-text-field-->
          <!--                v-model="latitude"-->
          <!--                :label="'Latitud'"-->
          <!--                filled-->
          <!--                dense-->
          <!--                readonly-->
          <!--                color="tertiary"-->
          <!--              />-->
          <!--            </v-col>-->
          <!--            <v-col cols="3">-->
          <!--              <v-text-field-->
          <!--                v-model="longitude"-->
          <!--                :label="'Longitud'"-->
          <!--                filled-->
          <!--                dense-->
          <!--                readonly-->
          <!--                color="tertiary"-->
          <!--              />-->
          <!--            </v-col>-->
          <!--          </v-row>-->
          <v-row class="d-flex justify-center">
            <v-col cols="12">
              <span class="tertiary--text text-body-2">
                {{
                  $t(
                    'fleet_management.points_of_interest.points_of_interest_detail.description_fields'
                  )
                }}
              </span>
              <v-textarea
                cols="12"
                v-model="description"
                filled
                dense
                color="tertiary"
                ref="pointsOfInterestDescription"
                rows="2"
              >
              </v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <hr class="divider-dotted" />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="my-3">
              <v-row justify="space-between">
                <v-col cols="auto">
                  <v-btn
                    @click="cancel"
                    outlined="true"
                    color="secondary"
                    rounded
                    >{{
                      $t(
                        'fleet_management.points_of_interest.create_points_of_interest.labels.form_new_poi_cancel_button'
                      )
                    }}</v-btn
                  >
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    color="tertiary white--text"
                    rounded
                    :loading="loading"
                    :disabled="!formHasChanged"
                    @click="saveEditedPoint"
                    >{{
                      $t(
                        'fleet_management.points_of_interest.create_points_of_interest.labels.form_new_poi_accept_button'
                      )
                    }}</v-btn
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
    <Dialog
      v-if="showDialog"
      idCancelButton="idBtnPuntosCancelarModificacion"
      idSubmitButton="idBtnPuntosAceptarModificacion"
      @cancelButtonPressed="showDialog = false"
      :loading="dialog.loading"
      :showDialog="showDialog"
      @submitButtonPressed="dialog.submitAction"
      :text="dialog.text"
      :title="dialog.title"
      type="warning"
    />
  </v-card>
</template>

<script>
import { i18n } from '@leapsight/portal'
import Dialog from '@/components/dialog/Dialog'
import { PointsHelpers } from '@/helpers/mainExports.js'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'EditPoint',
  components: {
    Dialog
  },
  data() {
    return {
      point: null,
      google: null,
      geocoder: null,
      pointsOfInterestName: '',
      iconSelected: null,
      location: '',
      selectedCategory: {
        name: ''
      },
      selectedCategoryIcons: {
        name: '',
        icon: ''
      },
      pointColor: '',
      dialog: {
        loading: false,
        text: '',
        title: '',
        type: '',
        submitAction: ''
      },
      id: null,
      label: '',
      latitude: null,
      longitude: null,
      description: '',
      loadingDialog: false,
      nameRules: [
        v =>
          !!v ||
          i18n.t('fleet_management.persons.new_person.rules.name_required'),
        v =>
          (v && v.length <= 40) ||
          i18n.t(
            'fleet_management.geofences.create_geofence.rules.character_length'
          ),
        v =>
          (v && v.length >= 2) ||
          i18n.t(
            'fleet_management.geofences.create_geofence.rules.character_length'
          )
      ],
      currentData: {},
      routeTo: { name: 'GeofencesList' },
      showDialog: false,
      valid: true,
      category: [
        { name: 'Clientes' },
        { name: 'Depósitos' },
        { name: 'Empresas' },
        { name: 'Estación de Servicio' },
        { name: 'Otras' },
        { name: 'Paradas autorizadas' },
        { name: 'Paradores' },
        { name: 'Parque Industrial' },
        { name: 'Plantas' },
        { name: 'Transportes' }
      ],
      categoryIcons: [
        { name: 'Clientes', icon: 'mdi-account' },
        { name: 'Depósitos', icon: 'mdi-warehouse' },
        { name: 'Empresas', icon: 'mdi-office-building' },
        {
          name: 'Estación de Servicio',
          icon: 'mdi-gas-station-in-use-outline'
        },
        { name: 'Otras', icon: 'mdi-star-outline' },
        { name: 'Paradas autorizadas', icon: 'mdi-check-decagram-outline' },
        { name: 'Paradores', icon: 'mdi-map-marker-radius-outline' },
        { name: 'Parque Industrial', icon: 'mdi-domain' },
        { name: 'Fábrica', icon: 'mdi-factory' },
        { name: 'Transportes', icon: 'mdi-truck-delivery-outline' }
      ]
    }
  },
  methods: {
    ...mapActions('ui', ['setSnackbar']),
    ...mapActions('mapState', ['setSearchBoxValue']),
    cancel() {
      this.$router.push({ name: 'PointsList' })
      this.$store.commit('pointOfInterest/setGeocodeResult', { geocodeResult: '' })
      this.$store.commit('pointOfInterest/setPointOfInterestGeoCoordinates', { lat: null, lng: null })
    },
    initializeSelectedValues() {
      if (!this.selectedCategory) {
        this.selectedCategory = ''
      }

      if (!this.selectedCategoryIcons || !this.selectedCategoryIcons.icon) {
        const defaultIcon = this.categoryIcons.find(
          icon => icon.name === 'Otras'
        )
        if (defaultIcon) {
          this.selectedCategoryIcons = defaultIcon
        }
      }
    },
    handleIconChange(newIcon) {
      this.selectedCategoryIcons = newIcon
    },
    async loadPointData() {
      try {
        this.loading = true
        this.id = this.$route.params.id
        const point = await PointsHelpers.getPoint({ id: this.id })

        if (point) {
          this.pointsOfInterestName = point.label
          this.selectedCategory = point.category
          this.iconSelected = point.icon
          this.pointColor = point.color
          const [lat, lng] = point.geometry?.coordinates
          this.$store.commit(
            'pointOfInterest/setPointOfInterestGeoCoordinates',
            { lat, lng }
          )
          this.description = point.description || ''
          this.selectedCategoryIcons =
            this.categoryIcons.find(icon => icon.icon === point.icon) ||
            this.categoryIcons[0]

          this.currentData = Object.assign({}, point)
        }
      } catch (error) {
        const snackbar = {
          color: 'error',
          text: i18n.t(
            'fleet_management.points_of_interest.points_of_interest_detail.error.loading_point_data'
          )
        }
        this.setSnackbar(snackbar)
      } finally {
        this.loading = false
      }
    },
    savePoint() {
      this.dialog.loading = true

      const currentData = this.currentData

      const payload = {}
      const updatedPoint = {
        label: this.pointsOfInterestName,
        color: this.pointColor,
        category:
          typeof this.selectedCategory === 'object' &&
          this.selectedCategory !== null
            ? this.selectedCategory.name
            : this.selectedCategory,
        icon: this.selectedCategoryIcons.icon,
        description: this.description,
        geometry: {
          coordinates: [
            this.getPointOfInterestGeoCoordinates.lat,
            this.getPointOfInterestGeoCoordinates.lng
          ]
        }
      }

      Object.keys(updatedPoint).forEach(key => {
        const newValue = updatedPoint[key]
        const originalValue = currentData[key]

        if (typeof newValue === 'object' && newValue !== null) {
          if (JSON.stringify(newValue) !== JSON.stringify(originalValue)) {
            payload[key] = newValue
          }
        } else if (newValue !== originalValue) {
          payload[key] = newValue
        }
      })

      if (Object.keys(payload).length === 0) {
        const snackbar = {
          color: 'info',
          text: i18n.t(
            'fleet_management.points_of_interest.points_of_interest_detail.alerts.there_are_no_changes'
          )
        }
        this.setSnackbar(snackbar)
        this.dialog.loading = false
        return
      }

      PointsHelpers.updatePoint(this.id, updatedPoint)
        .then(() => {
          this.dialog.loading = false
          this.showDialog = false
          document.getElementById('idLugaresAdministracionDireccion').value = ''
          this.$root.$emit('hideMarker')
          this.$router.push({ name: 'PointsList' })
          const snackbar = {
            color: 'success',
            text: i18n.t(
              'fleet_management.points_of_interest.points_of_interest_detail.alerts.point_edited'
            )
          }
          this.setSnackbar(snackbar)
        })
        .catch(error => {
          this.dialog.loading = false
          this.showDialog = false
          const errorText = PointsHelpers.getErrorMessageByCode(error.error)
          const snackbar = {
            text: errorText
          }
          this.setSnackbar(snackbar)
        })
    },
    saveEditedPoint() {
      if (this.$refs.form.validate()) {
        this.showDialog = true
        this.dialog.text = i18n.t(
          'fleet_management.points_of_interest.points_of_interest_detail.alerts.card_text_confirm_edit_point'
        )
        this.dialog.title = i18n.t(
          'fleet_management.points_of_interest.points_of_interest_detail.alerts.attention'
        )
        this.dialog.submitAction = this.savePoint
        this.$store.commit('pointOfInterest/setGeocodeResult', { geocodeResult: this.getGeocodeResult })
        this.$store.commit('pointOfInterest/setPointOfInterestGeoCoordinates', 
          { lat: this.getPointOfInterestGeoCoordinates.lat, 
            lng: this.getPointOfInterestGeoCoordinates.lng 
          })
      }
    },
    isPlusCode(address) {
      const hexRegex = /^[A-Z0-9]+\+\w+(?:\s|,|$)/
      const postalCodeRegex = /,\s?[A-Z]?\d{4}[A-Z]{0,3}(?:\s|,|$)/g

      if (hexRegex.test(address)) {
        let cleanedAddress = address.replace(hexRegex, '').trim()
        cleanedAddress = cleanedAddress.replace(postalCodeRegex, ',').trim()
        return cleanedAddress.length > 0 ? cleanedAddress : i18n.t(
            'fleet_management.points_of_interest.points_of_interest_detail.error.reference_not_available'
        )
      }

      return address.replace(postalCodeRegex, ',').trim()
    },
    getLocation() {
      this.geocoder = new google.maps.Geocoder()
      const lat = this.getPointOfInterestGeoCoordinates.lat
      const lng = this.getPointOfInterestGeoCoordinates.lng

      if (lat && lng) {
        const latLng = { lat, lng }
        this.geocoder.geocode({ location: latLng }, (results, status) => {
          if (status === 'OK' && results[0]) {
            let geocodeResult = results[0].formatted_address

            if (geocodeResult) {
              geocodeResult = this.isPlusCode(results[0].formatted_address)
            }
              this.$store.commit('pointOfInterest/setGeocodeResult', {
                geocodeResult
              })
          }
        })
      }
    },
    normalizeData(data) {
      return {
        label: data.label || '',
        color: data.color || '',
        category: data.category || '',
        icon: data.icon || '',
        description: data.description || '',
        geometry: {
          coordinates: data.geometry?.coordinates || [null, null]
        }
      }
    },
    getUpdatedPoint() {
      return {
        label: this.pointsOfInterestName,
        color: this.pointColor,
        category: this.selectedCategory || '',
        icon: this.selectedCategoryIcons.icon || '',
        description: this.description || '',
        geometry: {
          coordinates: [
            this.getPointOfInterestGeoCoordinates.lat,
            this.getPointOfInterestGeoCoordinates.lng
          ]
        }
      }
    },
    async emitMarkerIcon() {
      const p = this.currentData

      this.$root.$emit('marker-icon', {
        position: {
          lat: Number(p.geometry.coordinates[0]),
          lng: Number(p.geometry.coordinates[1])
        },
        icon: p.icon || 'mdi-star-outline',
        name: p.label,
        color: p.color
      })
    },
    updateLocation(newLocation) {
      this.location = newLocation
    }
  },
  computed: {
    ...mapGetters('auth', ['session']),
    ...mapGetters('pointOfInterest', [
      'getPoints',
      'getGeocodeResult',
      'getPointOfInterestGeoCoordinates'
    ]),
    getIcon() {
      return this.selectedCategoryIcons?.icon
    },
    formHasChanged() {
      const normalizedCurrentData = this.normalizeData(this.currentData)
      const normalizedUpdatedPoint = this.normalizeData(this.getUpdatedPoint())

      return (
        JSON.stringify(normalizedCurrentData) !==
        JSON.stringify(normalizedUpdatedPoint)
      )
    }
  },
  async mounted() {
    this.google = window.google
    await this.loadPointData()
    this.getLocation()
    this.emitMarkerIcon()

    document.getElementById('idLugaresAdministracionDireccion').value = ''

    this.$root.$on('location-updated', this.updateLocation)
  },
  created() {
    this.initializeSelectedValues()
  },
  beforeDestroy() {
    this.$root.$off('location-updated', this.updateLocation)

    if (
      this.point &&
      typeof this.point === 'object' &&
      Object.keys(this.point).length > 0
    ) {
      this.point.setMap(null)
      const map = PointsHelpers.getMap()
      google.maps.event.clearListeners(map, 'click')
    }
  }
}
</script>

<style lang="scss" scoped>
.orange--text {
  color: var(--orange) !important;
}
.dialog-attention {
  border: 2px solid var(--orange);
}
</style>
